export const APPLICATION_ID = "95";

/** Sakura ブランドの applicationId */
export const SAKURA_APPLICATION_ID = "84";

/** HIBANA ブランドの applicationId */
export const HIBANA_APPLICATION_ID = "132";

/** Renka ブランド（Android）の applicationId */
export const RENKA_ANDROID_APPLICATION_ID = "76";

export const WEB_APPLICATION_NAME = "Sina";

/**
 * コラボキャンペーン対象配信者（公式アカウント）の userId。BE 側の共通定数と同値で管理する。
 * BE の無料視聴ホワイトリストにはテスト用アカウントも含まれるため、
 * コラボヒーロー枠・BottomNav 演出はキャンペーン対象本人のみに固定する用途で使う。
 */
export const CAMPAIGN_USER_ID = "6a4b2a7f31d3314268d4a07f";

/** アプリの言語。sina は国内専用のため ja 固定（旧 i18n.language の置き換え） */
export const APP_LANGUAGE = "ja";

/** レビュアー匿名化用のモノトーンシルエットアバター（public 配下の静的アセット） */
export const REVIEWER_AVATAR_PATH = "/reviewer-avatar.svg";

/** 画像取得失敗時のデフォルトアバター（public 配下の静的アセット） */
export const DEFAULT_AVATAR_PATH = "/default-avatar.jpeg";

/** ポイント説明ページのベースURL */
export const POINTS_HELP_BASE_URL = "https://web2.miu-app.com/price/aira";

const ALVION_BASE_URL =
  import.meta.env.VITE_ALVION_URL ?? "https://web2.miu-app.com";

/** 問い合わせページのベースURL */
export const CONTACT_BASE_URL = `${ALVION_BASE_URL}/support/precautions`;
